import { useCallback, useEffect, useRef, useState } from 'react';
import { BROWSER_SESSION_EXPIRED_EVENT, BROWSER_SESSION_ROTATED_EVENT } from '../../services/api.ts';
import { getPlatformAvailabilityIdentity } from '../../services/platformAvailability.ts';

const keys = ['user_type', 'user_id', 'client_id', 'clinic_id', 'user_team', 'menu_permissions', 'menu_permissions_mode'];
export function readWorkflowClinic(): number | null {
  const id = Number(localStorage.getItem('clinic_id')); return Number.isInteger(id) && id > 0 ? id : null;
}
function identity(): string {
  return JSON.stringify([getPlatformAvailabilityIdentity(), ...keys.map(key => localStorage.getItem(key) || '')]);
}
/** Ephemeral request scope; this identity is never persisted or shown in the interface. */
export function useWorkflowScope() {
  const revision = useRef(0), expired = useRef(false);
  const readScope = useCallback(() => ({ clinicId: readWorkflowClinic(), expired: expired.current, key: `${identity()}|${revision.current}|${expired.current}` }), []);
  const [state, setState] = useState(readScope);
  useEffect(() => {
    const update = () => { revision.current += 1; setState(readScope()); };
    const ended = () => { expired.current = true; update(); };
    const rotated = () => { expired.current = false; update(); };
    const storage = (e: StorageEvent) => { if (e.key == null || keys.includes(e.key)) update(); };
    window.addEventListener('storage', storage); window.addEventListener('clinicChanged', update); window.addEventListener('userPermissionsChanged', update);
    window.addEventListener(BROWSER_SESSION_EXPIRED_EVENT, ended); window.addEventListener(BROWSER_SESSION_ROTATED_EVENT, rotated);
    return () => {
      window.removeEventListener('storage', storage); window.removeEventListener('clinicChanged', update); window.removeEventListener('userPermissionsChanged', update);
      window.removeEventListener(BROWSER_SESSION_EXPIRED_EVENT, ended); window.removeEventListener(BROWSER_SESSION_ROTATED_EVENT, rotated);
    };
  }, [readScope]);
  const current = readScope();
  return { ...(state.key === current.key ? state : current), readScope };
}
